/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_Move_DownInputs */

const cs_messages_move_down = /** @type {(inputs: Messages_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posunout dolů`)
};

const en_messages_move_down = /** @type {(inputs: Messages_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move down`)
};

/**
* | output |
* | --- |
* | "Move down" |
*
* @param {Messages_Move_DownInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const messages_move_down = /** @type {((inputs?: Messages_Move_DownInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Move_DownInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_move_down(inputs)
	return cs_messages_move_down(inputs)
});